AoPS.Utils.initKeyChain(AoPS, "Consultation", "Models");
AoPS.Consultation.Models = (function (Models) {
	var Ajax = AoPS.Ajax;
	var ajax_runner = new Ajax.ScriptRunner("/m/consultation/ajax-request.php");

	/**
	 * This seems to be the model entry point for the consultation module.
	 * It gets passed in to the router in request_main.js.
	 */
	Models.Master = AoPS.Model.extend({
		defaults: {
			has_errors: false,
		},

		initialize: function () {
			// Setup basic data sent in from the back end.
			this.set("season", AoPS.bd.season);
			this.set("campus", AoPS.bd.campus);
			this.set("is_staff", AoPS.bd.is_staff);

			// only allow a single parent for now
			this.set("allow_multi_parents", false);

			// Create the parent and student collection. This just makes
			// the collections, it does not add anything to the collection.
			// Think of these as an empty array which can hold Model.Parent
			// and Model.Student models.
			this.setParentCollection([]);
			this.setStudentCollection([]);

			switch (AoPS.bd.mode) {
				case "update":
					this.setupUpdate();
					break;
				case "schedule":
					this.setupSchedule();
					break;
				case "complete-student-profile":
					this.setupCompleteProfile();
					break;
				case "additional-consult":
					this.setupAdditionalConsult();
					break;
				default:
					this.setupNewRequest();
			}
		},

		/**
		 * Setup models for a new request, including blank student and parent
		 * records, or use data from their accounts if they exist.
		 */
		setupNewRequest: function () {
			this.set("view", "request_form");
			this.set("request_additional_info", null);
			this.set("email_consent", false);
			this.set("show_referral", AoPS.bd.show_referral || false);
			this.set("referral_ended", AoPS.bd.referral_ended || false);

			// create parent data - if parent account already exists,
			// as can be the case if enrolled in summer or virtual,
			// use data from parent account, otherwise, create new
			// parent record.
			if (AoPS.bd.consult_data && AoPS.bd.consult_data.parent) {
				var parent = this.createParentFromData(AoPS.bd.consult_data.parent);
				parent.setAttr("account_id", AoPS.bd.consult_data.parent.id);
				parent.setAttr(
					"platform_user_id",
					AoPS.bd.consult_data.parent.platform_user_id
				);
				this.get("parents").add(parent);
			} else {
				this.createParent();
			}

			// create student data
			// existing_students is passed as object keyed by account_id
			var existing_students =
				AoPS.bd.consult_data && AoPS.bd.consult_data.students
					? _.values(AoPS.bd.consult_data.students)
					: [];
			var uninitialized_students =
				AoPS.bd.consult_data && AoPS.bd.consult_data.uninitialized_students
					? AoPS.bd.consult_data.uninitialized_students
					: [];
			var all_students = existing_students.concat(uninitialized_students);
			if (all_students.length > 0) {
				var students = this.get("students");
				_.each(all_students, (data) => {
					var student = new Models.Student({}, {update: false});
					student.setAttr(
						"first_name",
						data.first_name || data.display_name,
						false
					);
					student.setAttr("display_name", data.display_name, false);
					// Could be their BA username, uninitialized on AoPS or
					// Online initialized Online username,
					student.setAttr("display_username", data.username, false);
					student.setAttr("grade", data.grade, false);
					student.setAttr("account_id", data.id, false);
					student.setAttr("platform_user_id", data.platform_user_id, false);
					students.add(student);
				});
			} else {
				this.createStudent();
			}

			// sets up referrer if necessary
			var referrer = null;
			if (this.get("show_referral")) {
				referrer = new Models.Referrer();
			}
			this.set("referrer", referrer);
		},

		/**
		 * Setup models for a request for existing students
		 */
		setupAdditionalConsult: function () {
			this.set("view", "additional_consult");
			this.set("request_additional_info", null);
			this.set("email_consent", false);

			// create parent data - if parent account already exists,
			// as can be the case if enrolled in summer or virtual,
			// use data from parent account, otherwise, create new
			// parent record.
			if (AoPS.bd.consult_data && AoPS.bd.consult_data.parent) {
				// This flow should only be hit for initialized parents, so
				// they should always have an account_id.
				var parent = this.createParentFromData(AoPS.bd.consult_data.parent);
				parent.setAttr("account_id", AoPS.bd.consult_data.parent.id);
				this.get("parents").add(parent);
			} else {
				this.createParent();
			}

			// existing_students is passed as object keyed by account_id
			var existing_students =
				AoPS.bd.consult_data && AoPS.bd.consult_data.students
					? _.values(AoPS.bd.consult_data.students)
					: [];
			var uninitialized_students =
				AoPS.bd.consult_data && AoPS.bd.consult_data.uninitialized_students
					? AoPS.bd.consult_data.uninitialized_students
					: [];
			var all_students = existing_students.concat(uninitialized_students);
			// create student data
			if (all_students.length > 0) {
				var students = this.get("students");
				_.each(all_students, (data) => {
					var student = new Models.Student({}, {update: false});
					student.setAttr(
						"first_name",
						data.first_name || data.display_name,
						false
					);
					student.setAttr("display_name", data.display_name, false);
					// Could be their BA username, uninitialized on AoPS or
					// Online initialized Online username,
					student.setAttr("display_username", data.username, false);
					student.setAttr("grade", data.grade, false);
					student.setAttr("account_id", data.id, false);
					student.setAttr("platform_user_id", data.platform_user_id, false);
					student.setAttr("interests", [], false);
					students.add(student);
				});
			} else {
				this.createStudent();
			}
		},

		setupUpdate: function () {
			if (!AoPS.bd.consult_data) {
				this.set("view", "hash_not_found");
			} else {
				this.set("staff_mode", AoPS.bd.is_staff);
				this.set("view", "update_form");
				this.set("update_single", false);
				this.set("should_scroll_on_render", false);
				this.set("hash", AoPS.bd.consult_data.hash);
				this.setSchoolData();
				this.get("parents").add(
					this.createParentFromData(AoPS.bd.consult_data.parent)
				);

				var students = this.get("students");
				var student_data = AoPS.bd.consult_data.students;
				_.each(
					student_data,
					function (data) {
						var student = this.createStudentFromData(data);
						students.add(student);
					},
					this
				);
			}
		},
		setupSchedule: function () {
			if (!AoPS.bd.consult_data || !AoPS.bd.consult_data.hash) {
				this.set("view", "scheduling_not_available");
			} else {
				this.set("view", "show_schedule");
				this.set("is_post_request", false);
				this.set("hash", AoPS.bd.consult_data.hash);
				this.set("service_id", AoPS.bd.consult_data.service_id || 0);
				this.set("schedule", new Models.Schedule({}, AoPS.bd.availabilities));
				this.set("can_update", Number(AoPS.bd.consult_data.can_update));
				this.set("can_go_forward", true);
				this.set("can_go_backwards", false);
				this.set("start_date", AoPS.bd.startDate);
				this.set("num_days", AoPS.bd.num_days);
				this.set("contact_id", AoPS.bd.contact_id || null);
			}
		},
		setupCompleteProfile: function () {
			this.set("staff_mode", AoPS.bd.is_staff);
			this.set("view", "update_form");
			this.set("update_single", true);
			this.set("should_scroll_on_render", false);
			this.setSchoolData();

			var students = this.get("students");
			var student_data = AoPS.bd.student;
			var student = this.createStudentFromData(student_data);
			students.add(student);
		},
		setSchoolData: function () {
			var schools = [];
			_.each(
				AoPS.bd.local_schools,
				function (label, school_id) {
					schools.push({
						value: school_id,
						label,
						selected: false,
					});
				},
				this
			);
			this.set(
				"school_data",
				new (Backbone.Collection.extend({
					model: Models.School,
					comparator: "label",
				}))(schools)
			);
		},
		setParentCollection: function (parent_records) {
			this.set(
				"parents",
				new (Backbone.Collection.extend({model: Models.Parent, request: this}))(
					parent_records
				)
			);
			this.get("parents").on("error_update", _.bind(this.setHasErrors, this));
		},
		setStudentCollection: function (student_records) {
			this.set(
				"students",
				new (Backbone.Collection.extend({model: Models.Student}))(
					student_records
				)
			);
			this.get("students").on("error_update", _.bind(this.setHasErrors, this));
		},
		createParent: function () {
			this.validateColl("parents");
			if (this.canCreateParent()) {
				this.get("parents").add(new Models.Parent());
				return true;
			} else {
				return false;
			}
		},
		createStudent: function () {
			this.validateColl("students");
			this.get("students").add(new Models.Student());
		},
		createParentFromData: function (data) {
			var parent = new Models.Parent();
			parent.setAttr("account_id", data.id, false);
			parent.setAttr("platform_user_id", data.platform_user_id, false);
			parent.setAttr("first_name", data.first_name, false);
			parent.setAttr("last_name", data.last_name, false);
			parent.setAttr("email_address", data.email, false);
			parent.setAttr("phone_number", data.phone1, false);
			return parent;
		},
		createStudentFromData: function (data) {
			var student = new Models.Student({}, {update: true});
			student.setAttr("first_name", data.first_name, false);
			student.setAttr("grade", data.grade, false);

			if (data.last_name === "(Incomplete)") {
				student.setAttr("last_name", null, false);
			} else {
				student.setAttr("last_name", data.last_name, false);
			}
			// if gender is "u", that is default, but we
			// don't automatically want to display that in
			// this case
			if (data.gender === "u") {
				data.gender = null;
			}
			student.setAttr("gender", data.gender, false);
			student.setAttr("birthday", data.birthday, false);
			student.setAttr("school_id", data.school_id, false);
			student.setAttr("school_name", data.school_name, false);
			student.setAttr("course", data.course, false);
			// we use additional info to store other things, and we
			// don't want the parent to accidentally mess that up, so
			// just give them a blank slate and then we can concat
			// on the back end.
			student.setAttr("additional_info", null, false);
			student.setAttr("emergency_name", data.emergency_name, false);
			student.setAttr("emergency_phone", data.emergency_phone, false);
			student.setAttr(
				"emergency_relationship",
				data.emergency_relationship,
				false
			);
			student.setAttr("account_id", data.id, false);
			student.setAttr("aops_user_id", data.aops_user_id, false);

			return student;
		},
		canCreateParent: function () {
			return !this.get("parents").length || this.get("allow_multi_parents");
		},
		validateColl: function (name, opts = {}) {
			var people = this.get(name);
			// Validate all new students
			people.each(function (person) {
				if (
					name !== "students" ||
					!person.get("platform_user_id") ||
					!person.get("platform_user_id").get("value")
				) {
					person.validateAttrs(opts);
				}
			}, this);
			// Validate existing students, but just the selected ones
			this.validateSelectedStudents();
			this.setHasErrors();
		},
		validateSingle: function (name, opts = {}) {
			var person = this.get(name);
			person.validateAttrs(opts);
			this.setHasErrors();
		},
		setHasErrors: function () {
			var parents_have_errors = this.doesCollectionHaveErrors("parents");
			var students_have_errors = this.doesCollectionHaveErrors("students");
			var referrer_has_errors = this.doesSingleHaveErrors("referrer");
			this.set(
				"has_errors",
				parents_have_errors || students_have_errors || referrer_has_errors
			);
		},
		selectedStudentHasErrors: function (student) {
			var initialized = !!student.get("account_id").get("value");
			// This student is selected, need to verify they have interests
			var student_interests = student.get("interests").get("value");
			if (
				student_interests &&
				Array.isArray(student_interests) &&
				student_interests.length === 0
			) {
				return true;
			}
			// If student is not initialized, we also need to require
			// first name and grade.
			if (
				!initialized &&
				(!student.get("first_name").get("value") ||
					!student.get("grade").get("value"))
			) {
				return true;
			}
			return false;
		},
		getSelectedStudents: function () {
			var selected_student_ids = this.selected_student_ids || [];
			var selected_students = [];
			if (selected_student_ids.length) {
				selected_students = this.get("students").filter((s) =>
					selected_student_ids.includes(s.get("platform_user_id").get("value"))
				);
			}
			return selected_students;
		},
		validateSelectedStudents: function () {
			// Set has_error on each student
			var students = this.get("students");
			if (students.length) {
				var selected_student_ids = this.selected_student_ids || [];
				students.each((student) => {
					if (
						student.get("platform_user_id") &&
						selected_student_ids.includes(
							student.get("platform_user_id").get("value")
						)
					) {
						var has_error = this.selectedStudentHasErrors(student);
						student.set("has_errors", has_error);
					} else if (
						// Unset errors for those that aren't selected
						student.get("platform_user_id") &&
						student.get("platform_user_id").get("value")
					) {
						student.set("has_errors", false);
					}
				});
			}
		},
		updateSelectedStudents: function (platform_user_id, is_checked) {
			if (is_checked) {
				if (this.selected_student_ids) {
					if (!this.selected_student_ids.includes(platform_user_id)) {
						// If platform_user_ids doesn't include this account, adds it
						this.selected_student_ids.push(platform_user_id);
					}
				} else {
					// platform_user_ids somehow doesn't exist, so set it to a new 1-length array of this account
					this.selected_student_ids = [platform_user_id];
				}
			} else {
				if (
					this.selected_student_ids &&
					this.selected_student_ids.includes(platform_user_id)
				) {
					// platform_user_ids contains this account, but it's box is unchecked, so we remove it
					this.selected_student_ids = this.selected_student_ids.filter(
						(id) => id !== platform_user_id
					);
				}
			}
		},

		doesCollectionHaveErrors: function (key) {
			var has_errors = false;
			var people = this.get(key);
			people.each(function (person) {
				if (person.get("has_errors")) {
					has_errors = true;
				}
			}, this);
			return has_errors;
		},
		doesSingleHaveErrors: function (key) {
			var single = this.get(key);
			if (single) {
				return single.get("has_errors");
			}
			// something that doesn't exist can't have errors
			return false;
		},
		submitRequest: function (success, selectedStudents) {
			// Start with all the new students
			var students = this.get("students").filter(
				(s) =>
					!(s.get("platform_user_id") && s.get("platform_user_id").get("value"))
			);
			if (selectedStudents && selectedStudents.length) {
				if (!students.length) {
					students = selectedStudents;
				} else {
					students = students.concat(selectedStudents);
				}
			}
			var postJSON = {
				parents: JSON.stringify(this.get("parents")),
				students: JSON.stringify(students),
				referrer: JSON.stringify(this.get("referrer")),
				additional_info: this.get("request_additional_info"),
				email_consent: this.get("email_consent"),
				hash: this.get("hash"),
			};
			var cdid = "";
			if (window.localStorage) {
				cdid = window.localStorage.getItem("cdid");
			}
			postJSON["cdid"] = cdid;

			ajax_runner.run(
				"submit-consultation-request",
				postJSON,
				_.bind(function (ok, data) {
					if (!ok) {
						this.handleAjaxError(data);
					} else {
						let parent = postJSON.parents;
						if (!AoPS.Numbers) {
							console.error(
								"E_MISSING_SCRIPT",
								"lib.js is not loaded! Not sending event to /numbers/ajax"
							);
						} else if (parent) {
							parent = JSON.parse(parent);
							if (parent) {
								parent = parent[0];

								AoPS.Numbers.sendEvent({
									a: "capi_lead",
									email: parent.email_address,
									phone: parent.phone_number,
									first: parent.first_name,
									last: parent.last_name,
								});
							} else {
								console.error(
									"E_NO_PARENTS",
									"This purchase does not have any parents listed in its parent data. Not sending event to /numbers/ajax"
								);
							}
						} else {
							console.error(
								"E_MISSING_PARENTS",
								":( This purchase is missing its parents! You should not get this error because we must know who made the purchase. Not sending event to /numbers/ajax"
							);
						}

						this.reportRequestToAnalytics();
						this.set("hash", data.response.hash);
						this.set("service_id", data.response.serviceId || 0);

						if (data.response.availabilities) {
							this.set("view", "show_schedule");
							this.set("is_post_request", true);
							this.set(
								"schedule",
								new Models.Schedule({}, data.response.availabilities)
							);
							this.trigger("refreshSchedule");
						} else {
							this.set("view", "success_message");
						}
					}
					if (success instanceof Function) {
						success();
					}
				}, this)
			);
		},

		submitUpdate: function () {
			var update_single = this.get("update_single");
			var update_type = "update-consultation-request";
			if (update_single) {
				update_type = "complete-profile";
			}
			var first_student = this.get("students").first();
			var first_ec_name = first_student.get("emergency_name").get("value");
			var first_ec_phone = first_student.get("emergency_phone").get("value");
			var first_ec_relationship = first_student
				.get("emergency_relationship")
				.get("value");

			var needs_aops_account = false;
			this.get("students").each(
				_.bind(function (student, index) {
					if (
						AoPS.bd.student &&
						student.get("account_id").get("value") === AoPS.bd.student.id &&
						!student.get("aops_user_id").get("value")
					) {
						needs_aops_account = true;
					}

					if (!index) {
						return;
					}

					if (student.get("use_first_ec").get("value")) {
						student.setAttr("emergency_name", first_ec_name);
						student.setAttr("emergency_phone", first_ec_phone);
						student.setAttr("emergency_relationship", first_ec_relationship);
					}
				}, this)
			);

			ajax_runner.run(
				update_type,
				JSON.parse(JSON.stringify(this)),
				_.bind(function (ok, data) {
					if (!ok) {
						this.handleAjaxError(data);
					} else {
						if (update_single) {
							if (needs_aops_account) {
								window.location.href =
									"/account/associate?student_id=" +
									AoPS.bd.student.id +
									"&class_id=" +
									AoPS.bd.class_id;
							} else {
								$.post(
									"/m/courses/ajax.php",
									{
										action: "enroll",
										student_id: AoPS.bd.student.id,
										class_id: AoPS.bd.class_id,
									},
									_.bind(function (d) {
										if (d.error_code || d.error_msg) {
											this.handleAjaxError(d);
										} else {
											this.reportRequestToAnalytics();
											window.location.href = "/store/checkout";
										}
									}, this)
								);
							}
						} else {
							this.set("view", "update_success_message");
						}
					}
				}, this)
			);
		},
		completeProfile: function () {
			this.submitUpdate();
		},
		scheduleAppointment: function (availabilityObj, success) {
			ajax_runner.run(
				"book-consultation",
				{
					serviceId: this.get("service_id"),
					hash: this.get("hash"),
					availability: JSON.stringify(availabilityObj.attributes),
				},
				_.bind(function (ok, data) {
					if (!ok) {
						this.set("view", "unknown_onsched_error");
					} else {
						if (!data.response.success) {
							this.set(
								"schedule",
								new Models.Schedule({}, data.response.availabilities)
							);
						}
						if (success instanceof Function) {
							success(data);
						}
					}
				}, this)
			);
		},
		handleAjaxError: function (data) {
			var key = null;
			switch (data.error_code) {
				case "E_MULTIPLE_PARENTS":
					this.trigger("change");
					AoPS.Ui.Flyout.queue(
						"Something unexpected happened.  If this continues to happen, please contact tech support."
					);
					break;
				case "E_PARENT_HAS_ACCOUNT":
					this.set("view", "parent_has_account_error");
					this.set("existing_account_email", data.error_msg[0].email_address);
					break;
				case "E_ACTIVE_HASH_NOT_FOUND":
					this.set("view", "hash_not_found");
					break;
				case "E_INVALID_USERNAME":
				case "E_AOPS_USER_ALREADY_LINKED":
				case "E_AOPS_USER_NOT_FOUND":
					key = "username";
					break;
				case "E_INVALID_PASSWORD":
				case "E_INVALID_COMMON_PASSWORD":
				case "E_AOPS_USER_NOT_AUTHENTICATED":
					key = "password";
					break;
				case "E_INVALID_EMAIL":
					key = "email_address";
					break;
				default:
					var msg =
						"Something unexpected happened.  If this continues to happen, please contact tech support.";
					if (data.error_msg) {
						msg = data.error_msg;
					}
					this.trigger("change");
					AoPS.Ui.Flyout.queue(msg);
					break;
			}
			if (key) {
				var elem = this.get("students").first().get(key);
				elem.set("errors", data.error_msg);
				elem.set("has_errors", true);
				this.setHasErrors();
			}
		},
		toJSON: function () {
			return {
				parents: JSON.stringify(this.get("parents")),
				students: JSON.stringify(this.get("students")),
				referrer: JSON.stringify(this.get("referrer")),
				additional_info: this.get("request_additional_info"),
				email_consent: this.get("email_consent"),
				hash: this.get("hash"),
			};
		},
		reportRequestToAnalytics: function () {
			if (AoPS.bd.is_staff) {
				// don't report in staff mode
				return;
			}
			var role = "not_registered";
			if (AoPS.session.logged_in) {
				var roles = AoPS.session.role.split(",");
				if (roles.indexOf("officestaff") >= 0 || roles.indexOf("admin") >= 0) {
					role = "staff";
				} else if (roles.indexOf("parent") >= 0) {
					role = "parent";
				} else {
					role = "registered_user";
				}
			}
			var event = "consult-flow";
			var event_type;
			switch (AoPS.bd.mode) {
				case "update":
					event_type = "completed-additional-info-";
					break;
				case "complete-student-profile":
					event_type = "completed-profile-after-consult";
					break;
				default:
					event_type = "initial-consult-request";
			}
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push({
				event: event,
				event_type: event_type,
				campus: Academy.campus.id,
				joined_maillist: this.get("email-consent"),
				logged_in: AoPS.session.logged_in,
				role: role,
			});
		},
		requestMoreAvailability: function (direction, success) {
			ajax_runner.run(
				"get-onsched-availability",
				{
					serviceId: this.get("service_id"),
					direction: direction,
					startDate: this.get("start_date"),
					numDays: this.get("num_days"),
					contactId: this.get("contact_id"),
				},
				_.bind(function (ok, data) {
					if (!ok) {
						this.handleAjaxError(data);
					} else {
						if (data.response.availabilities) {
							this.set(
								"schedule",
								new Models.Schedule({}, data.response.availabilities)
							);
							this.trigger("refreshSchedule");
						}
					}
					if (success instanceof Function) {
						success();
					}
				}, this)
			);
		},
	});

	Models.Person = AoPS.Model.extend({
		defaults: {
			has_errors: false,
		},
		setAttributeKeys: function (attribute_keys) {
			this.attribute_keys = attribute_keys;
		},
		initializeAttributes: function () {
			_.each(
				this.attribute_keys,
				function (key) {
					this.set(key, new Models.DataElement({key: key}));
					if (key === "use_first_ec") {
						this.get(key).set("value", true);
					}
					this.listenTo(this.get(key), "change", function (changed) {
						var starting_has_errors = this.get("has_errors");
						this.setHasErrors();
						if (starting_has_errors && this.get("has_errors")) {
							// we already had errors, and that hasn't changed
							// but we need to trigger a change event in order
							// to allow the template to render any new error
							// messages
							this.trigger("change");
						} else if (changed.get("key") === "use_first_ec") {
							this.trigger("change");
						}
					});
				},
				this
			);
		},
		setAttr: function (key, value, validate = true, validate_opts = {}) {
			var elem = this.get(key);
			if (elem) {
				elem.set({
					value: value,
					has_errors: false,
					errors: [],
				});
				if (validate) {
					elem.validateElement(validate_opts, this);
				}
				if (key === "use_first_ec") {
					this.setAttr("emergency_name", null, value);
					this.setAttr("emergency_phone", null, value);
					this.setAttr("emergency_relationship", null, value);
				}
				this.setHasErrors();
			}
		},
		setHasErrors: function () {
			var has_errors = false;
			_.each(
				this.attribute_keys,
				function (key) {
					var attr_elem = this.get(key);
					if (attr_elem.get("has_errors")) {
						has_errors = true;
					}
				},
				this
			);
			this.set("has_errors", has_errors);
			this.trigger("error_update");
		},
		validateAttrs: function (opts = {}) {
			_.each(
				this.attribute_keys,
				function (key) {
					this.get(key).validateElement(opts, this);
				},
				this
			);
			this.setHasErrors();
		},
		clearAttrErrors: function () {
			_.each(
				this.attribute_keys,
				function (key) {
					var attr = this.get(key);
					attr.set("errors", []);
					attr.set("has_errors", false);
				},
				this
			);
			this.setHasErrors();
		},
		toJSON: function () {
			var data = {};
			_.each(
				this.attribute_keys,
				function (key) {
					data[key] = this.get(key).get("value");
				},
				this
			);
			return data;
		},
	});

	/**
	 * Extends Models.Person
	 */
	Models.Parent = Models.Person.extend({
		initialize: function () {
			var attr_keys = [
				"first_name",
				"last_name",
				"email_address",
				"phone_number",
				"account_id",
				"platform_user_id",
			];
			this.setAttributeKeys(attr_keys);
			this.initializeAttributes();
		},
	});

	/**
	 * Extends Models.Person
	 */
	Models.Student = Models.Person.extend({
		initialize: function (attrs, opts) {
			var attr_keys = [
				"first_name",
				"grade",
				"account_id",
				"platform_user_id",
				"display_name",
				"display_username",
				"aops_user_id",
			];
			var update_keys = [
				"last_name",
				"gender",
				"birthday",
				"school_id",
				"school_name",
				"course",
				"additional_info",
				"emergency_name",
				"emergency_phone",
				"emergency_relationship",
				"account_id",
				"use_first_ec",
			];
			if (opts && opts.update) {
				attr_keys = attr_keys.concat(update_keys);
				this.set("selected_birth_month", 0);
				this.setBirthMonthData();
				this.set("selected_birth_day", 0);
				this.setBirthDayData();
				this.set("selected_birth_year", 0);
				this.setBirthYearData();
			} else {
				attr_keys.push("interests");
			}
			this.setAttributeKeys(attr_keys);
			this.initializeAttributes();
			if (!opts || !opts.update) {
				this.get("interests").set("value", []);
			}
		},
		setBirthMonthData: function () {
			var selected = this.get("selected_birth_month");
			var month_names = [
				"January",
				"February",
				"March",
				"April",
				"May",
				"June",
				"July",
				"August",
				"September",
				"October",
				"November",
				"December",
			];
			var month_data_objs = [];
			_.each(month_names, function (name, index) {
				month_data_objs.push({
					value: index + 1, // 1-index
					label: name,
					selected: Number(selected) === index + 1,
				});
			});
			this.set("birth_month_data", month_data_objs);
		},
		setBirthDayData: function () {
			var selected = this.get("selected_birth_day");
			var max = 31;
			if (this.get("selected_birth_month")) {
				switch (this.get("selected_birth_month")) {
					case "2":
						max = 29;
						if (this.get("selected_birth_year")) {
							if (!moment([this.get("selected_birth_year")]).isLeapYear()) {
								max = 28;
							}
						}
						break;
					case "4":
					case "6":
					case "9":
					case "11":
						max = 30;
						break;
				}
			}
			var day_data_objs = [];
			for (var i = 1; i <= max; i++) {
				day_data_objs.push({
					value: i,
					label: i,
					selected: Number(selected) === i,
				});
			}
			this.set("birth_day_data", day_data_objs);
		},
		setBirthYearData: function () {
			var selected = this.get("selected_birth_year");
			var max = moment().year() - 3;
			var min = moment().year() - 21;
			var year_data_objs = [];
			for (var i = min; i <= max; i++) {
				year_data_objs.push({
					value: i,
					label: i,
					selected: Number(selected) === i,
				});
			}
			this.set("birth_year_data", year_data_objs);
		},
		setBirthdayAttr: function (type, val, validate_opts = {}) {
			if (type === "month") {
				this.set("selected_birth_month", val);
				this.setBirthMonthData();
			} else if (type === "day") {
				this.set("selected_birth_day", val);
				this.setBirthDayData();
			} else if (type === "year") {
				this.set("selected_birth_year", val);
				this.setBirthYearData();
			}
			var month = this.get("selected_birth_month");
			var day = this.get("selected_birth_day");
			var year = this.get("selected_birth_year");
			if (month && day && year) {
				// set birthday, we have all the parts
				if (day.length < 2) {
					day = 0 + day;
				}
				if (month.length < 2) {
					month = 0 + month;
				}
				var birthday = [year, month, day].join("-");
				this.setAttr("birthday", birthday);
			}
			if (!val) {
				// if val is empty, we should
				// go ahead and validate to display an error
				// and keep consistent onBlur behavior.
				this.get("birthday").validateElement(validate_opts, this);
			}
		},
		getParsedInterests: function () {
			var interests = this.get("interests");
			interests = interests ? interests.get("value") : [];

			var student_interests = [
				{
					value: "math",
					text: "Math",
					checked: interests.indexOf("math") >= 0,
				},
				{
					value: "science",
					text: "Science",
					checked: interests.indexOf("science") >= 0,
				},
				{
					value: "la",
					text: "Language Arts",
					checked: interests.indexOf("la") >= 0,
				},
			];
			return student_interests;
		},
		getParsedGrade: function () {
			var grade_map = AoPS.bd.grade_map;
			var grade = this.get("grade").get("value");
			if (grade !== null) {
				grade = Number(grade);
			}
			var grade_levels = [];
			// this has incorrect ordering and possibly type issues but it's deprecated anyways
			Object.entries(grade_map).forEach(([value, single_grade]) => {
				grade_levels.push({
					value: value,
					text: single_grade,
					selected: grade === Number(value),
				});
			});
			return grade_levels;
		},
		submitRequest: function (success) {
			var postJSON = JSON.parse(JSON.stringify(this));

			ajax_runner.run(
				"submit-consultation-request",
				postJSON,
				_.bind(function (ok, data) {
					if (!ok) {
						this.handleAjaxError(data);
					} else {
						this.reportRequestToAnalytics();
						this.set("hash", data.response.hash);
						this.set("service_id", data.response.serviceId || 0);

						if (data.response.availabilities) {
							this.set("view", "show_schedule");
							this.set("is_post_request", true);
							this.set(
								"schedule",
								new Models.Schedule({}, data.response.availabilities)
							);
							this.trigger("refreshSchedule");
						} else {
							this.set("view", "success_message");
						}
					}
					if (success instanceof Function) {
						success();
					}
				}, this)
			);
		},
	});

	Models.Referrer = Models.Person.extend({
		initialize: function () {
			this.setAttributeKeys(["referrer_name", "referrer_email_address"]);
			this.initializeAttributes();
		},
	});

	/**
	 * Seems to validate data
	 */
	Models.DataElement = AoPS.Model.extend({
		defaults: {
			value: null,
			has_errors: false,
			errors: [],
			key: null,
		},
		initialize: function () {
			this.season = AoPS.bd.season;
		},
		// not using the built-in validate
		// because I still want to set the value,
		// I just want to mark it errored;
		validateElement: function (opts = {}, context = {}) {
			var errors = [];
			var value = this.get("value");
			var key = this.get("key");
			switch (key) {
				case "first_name":
					errors = this.validateString(value, errors, "First Name");
					break;
				case "last_name":
					errors = this.validateString(value, errors, "Last Name");
					break;
				case "referrer_name":
					errors = this.validateString(value, errors, "Referrer Name");
					break;
				case "birthday":
					errors = this.validateRequired(value, errors, "Date of Birth");
					break;
				case "emergency_name":
					if (this.shouldValidateEC(context)) {
						errors = this.validateString(
							value,
							errors,
							"Emergency Contact Name"
						);
					}
					break;
				case "emergency_relationship":
					if (this.shouldValidateEC(context)) {
						errors = this.validateRequired(
							value,
							errors,
							"Emergency Contact Relationship"
						);
					}
					break;
				case "email_address":
					if (!opts.update) {
						errors = this.validateEmailAddress(
							value,
							errors,
							"Parent Email Address"
						);
					}
					break;
				case "referrer_email_address":
					errors = this.validateEmailAddress(
						value,
						errors,
						"Referrer Email Address"
					);
					break;
				case "phone_number":
					errors = this.validatePhoneNumber(value, errors);
					break;
				case "emergency_phone":
					if (this.shouldValidateEC(context)) {
						errors = this.validatePhoneNumber(
							value,
							errors,
							"Emergency Contact Phone"
						);
					}
					break;
				case "grade":
					errors = this.validateGradeLevel(value, errors);
					break;
				case "interests":
					errors = this.validateInterests(value, errors);
					break;
				case "school_id":
					errors = this.validateRequired(value, errors, "School");
					break;
				case "course":
					if (!opts.update_single) {
						errors = this.validateRequired(
							value,
							errors,
							"Current Math Course"
						);
					}
					break;
				case "gender":
					errors = this.validateRequired(value, errors, "Gender");
					break;
			}
			this.set("errors", errors);
			if (errors.length) {
				this.set("has_errors", true);
			}
		},
		validateString: function (
			value,
			errors,
			friendly_text,
			required = true,
			words = false
		) {
			if (!value) {
				if (required) {
					errors.push(friendly_text + " is required.");
				}
				return errors;
			}
			if (!words && !this.checkLettersAndSpaces(value)) {
				errors.push(
					friendly_text +
						" can only contain letters and spaces, and must start with a letter."
				);
			} else if (words && !this.checkWords(value)) {
				errors.push(
					friendly_text +
						" must start with a letter or number and can only contain letters, numbers, spaces, and any of the following special characters: . , /"
				);
			}
			return errors;
		},
		validateEmailAddress: function (
			value,
			errors,
			friendly_name = "Email Address"
		) {
			if (!value) {
				errors.push(friendly_name + " is required.");
			} else if (
				!/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
					value
				)
			) {
				errors.push("Please enter a valid email address.");
			}
			return errors;
		},
		validatePhoneNumber: function (
			value,
			errors,
			friendly_name = "Phone Number"
		) {
			if (!value) {
				errors.push(friendly_name + " is required.");
				return errors;
			}
			if (this.checkNANPPhone(value)) {
				// valid north american number, format it into
				// our preferred format
				// this.set("value", this.formatNANPPhone(value));
			} else if (!this.checkInternationalPhone(value)) {
				// invalid number
				errors.push(
					"Please enter a valid US or international phone number for " +
						friendly_name +
						".  US numbers should be entered as 10-digit numbers in the format XXX-XXX-XXXX.  If entering an international number, please prefix your number with the '+' symbol and your country code."
				);
			}
			return errors;
		},
		validateZipcode: function (value, errors) {
			if (!value) {
				errors.push("Zipcode is required.");
			} else if (!this.checkZipcode(value)) {
				errors.push(
					"Zipcode must be either 5 digits with no punctuation, or 9 digits in the format XXXXX-XXXX."
				);
			}
			return errors;
		},
		validateGradeLevel: function (value, errors) {
			if (value === null || isNaN(value)) {
				errors.push(
					"Please select your child's grade level during the " +
						this.season +
						" school year."
				);
			}
			return errors;
		},
		validateInterests: function (value, errors) {
			if (!value.length) {
				errors.push(
					"Please select the programs you are interested in for your child."
				);
			}
			return errors;
		},
		validateRequired: function (value, errors, friendly_name) {
			if (!value) {
				errors.push(friendly_name + " is required.");
			}
			return errors;
		},
		checkLettersAndSpaces: function (string) {
			return /^[a-zA-Z]+[a-zA-Z\s]*$/.test(string);
		},
		checkWords: function (string) {
			return /^[a-zA-Z0-9]+[\w\s\.\/,]*$/.test(string);
		},
		checkInternationalPhone: function (num) {
			return /^\+[1-9]{1}[0-9]{3,14}$/.test(num.replace(/[^0-9+]/g, ""));
		},
		checkNANPPhone: function (num) {
			if (num.slice(0, 2) === "+1") {
				num = num.slice(2);
			}
			return /^\(?[2-9][0-8][0-9]\)?[\s\.\-\/\\]?[2-9][0-9]{2}[\s\.\-\/\\]?[0-9]{4}/.test(
				num
			);
		},
		checkZipcode: function (value) {
			return /^[0-9]{5}(?:-[0-9]{4})?$/.test(value);
		},
		formatNANPPhone: function (num) {
			var new_num = num;
			if (new_num.slice(0, 2) === "+1") {
				new_num = new_num.slice(2);
			}
			new_num = new_num.replace(/\D/g, "");
			if (isNaN(new_num) || new_num.length !== 10) {
				return num;
			}
			return (
				new_num.slice(0, 3) + "-" + new_num.slice(3, 6) + "-" + new_num.slice(6)
			);
		},
		shouldValidateEC: function (context) {
			var index = context.collection.indexOf(context);
			var use_first = context.get("use_first_ec").get("value");
			return index === 0 || !use_first;
		},
	});

	Models.School = AoPS.Model.extend({
		idAttribute: "value",
		initialize: function (options) {
			this.set("label", options.label);
			this.set("value", options.value);
		},
	});

	Models.Schedule = AoPS.Model.extend({
		initialize: function (attrs, data) {
			var days = _.map(data, function (openings, date) {
				return {date: date, data: openings};
			});

			this.set(
				"days",
				new (Backbone.Collection.extend({
					model: Models.ScheduleDay,
					comparator: "date",
				}))(days)
			);

			// "fill in the blanks" by adding days between the first and
			// last returned date that don't already exist
			days = this.get("days");
			var current = moment(days.first().get("date")).add(1, "d");
			var last = moment(days.last().get("date"));

			while (current < last) {
				// collection.add does nothing if the element already exists
				days.add({date: current.format("YYYY-MM-DD"), data: []});
				current.add(1, "d");
			}
		},
	});

	Models.ScheduleDay = AoPS.Model.extend({
		idAttribute: "date",
		initialize: function (day) {
			this.set("date", day.date);
			this.set(
				"openings",
				new (Backbone.Collection.extend({
					model: Models.ScheduleOpening,
					comparator: "time",
				}))(day.data)
			);
			this.unset("data");
		},
	});

	Models.ScheduleOpening = AoPS.Model.extend({
		idAttribute: "time",
		initialize: function () {
			this.set("displayTime", this.get("displayTime"));
			this.set("moment", moment(this.get("startDateTime")));
		},
	});

	return Models;
})(AoPS.Consultation.Models || {});
